var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _path7, _g4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMirinaeLogo = function SvgIconMirinaeLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 35,
    viewBox: "0 0 142 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_22591",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 9,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5227 9.10791H94.4512V25.9002H79.5227V9.10791Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_22591)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4925 25.9004C91.4109 25.9004 90.5339 25.0227 90.5339 23.9404V16.6404C90.5339 15.6132 90.1175 14.6789 89.3906 14.0771C87.786 12.7494 86.3671 12.6753 84.7929 13.8412C83.9463 14.4677 83.44 15.492 83.44 16.5809V23.9404C83.44 25.0227 82.563 25.9004 81.4813 25.9004C80.3997 25.9004 79.5227 25.0227 79.5227 23.9404V16.5809C79.5227 14.2542 80.6224 12.0518 82.4636 10.6892C85.4763 8.45984 88.9097 8.59268 91.8868 11.0565C93.5168 12.4053 94.4512 14.4408 94.4512 16.6404V23.9404C94.4512 25.0227 93.5741 25.9004 92.4925 25.9004Z",
    fill: "#3C3C3B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_201_22591",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 9,
    width: 27,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8481 9.10791H37.7871V25.9004H11.8481V9.10791Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_201_22591)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7988 10.6892C25.4324 10.9607 25.1045 11.2729 24.7998 11.6053C24.6156 11.4122 24.4197 11.2286 24.2123 11.0565C21.2366 8.59344 17.8017 8.45914 14.789 10.6892C12.9472 12.0518 11.8481 14.2543 11.8481 16.5809V23.9404C11.8481 25.0228 12.7252 25.9004 13.8068 25.9004C14.8884 25.9004 15.7654 25.0228 15.7654 23.9404V16.5809C15.7654 15.492 16.271 14.4677 17.1176 13.8412C18.6925 12.6754 20.11 12.7494 21.7153 14.0771C22.4422 14.6789 22.8586 15.6125 22.8586 16.6404V23.9404C22.8586 25.0228 23.7357 25.9004 24.8173 25.9004C25.8989 25.9004 26.7759 25.0228 26.7759 23.9404V16.6404V16.5809C26.7759 15.492 27.2815 14.4677 28.1288 13.8412C29.703 12.6754 31.1205 12.7494 32.7265 14.0771C33.4527 14.6789 33.8691 15.6125 33.8691 16.6404V23.9404C33.8691 25.0228 34.7461 25.9004 35.8277 25.9004C36.9101 25.9004 37.7871 25.0228 37.7871 23.9404V16.6404C37.7871 14.4408 36.852 12.4053 35.2227 11.0565C32.247 8.59344 28.8129 8.45914 25.7988 10.6892Z",
    fill: "#3C3C3B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_201_22591",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 9,
    width: 13,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7766 9.10303H64.5124V25.9005H52.7766V9.10303Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_201_22591)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7353 25.9007C53.6536 25.9007 52.7766 25.023 52.7766 23.9407V16.5812C52.7766 14.2545 53.8756 12.0521 55.7175 10.6895C58.1651 8.879 60.913 8.60895 63.4548 9.92652C64.4153 10.4252 64.7896 11.6085 64.2927 12.5689C63.7943 13.5301 62.6119 13.9046 61.6522 13.4074C60.8897 13.0125 59.6877 12.627 58.0461 13.8415C57.1995 14.468 56.6939 15.4923 56.6939 16.5812V23.9407C56.6939 25.023 55.8169 25.9007 54.7353 25.9007Z",
    fill: "#3C3C3B"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1189 10.3712L49.9875 22.9647C50.4743 24.0093 50.0702 25.2288 49.0844 25.6891C48.0985 26.1486 46.9052 25.6746 46.4185 24.6307L40.5498 12.0364C40.063 10.9911 40.4671 9.77226 41.4529 9.31202C42.4388 8.85178 43.6321 9.32654 44.1189 10.3712Z",
    fill: "#87CBC8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7273 22.9647C77.214 24.0093 76.8093 25.2288 75.8241 25.6891C74.8383 26.1486 73.645 25.6746 73.1575 24.6307L67.2895 12.0364C66.8028 10.9911 67.2068 9.77226 68.1927 9.31202C69.1785 8.85178 70.3719 9.32654 70.8586 10.3712L76.7273 22.9647Z",
    fill: "#87CBC8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.474 21.9805C102.006 21.9805 99.997 19.9704 99.997 17.5007C99.997 15.0304 102.006 13.021 104.474 13.021C106.942 13.021 108.95 15.0304 108.95 17.5007C108.95 19.9704 106.942 21.9805 104.474 21.9805ZM104.473 9.10107C99.8453 9.10107 96.0796 12.8687 96.0796 17.5009C96.0796 22.1323 99.8453 25.9006 104.473 25.9006C106.162 25.9006 107.733 25.3947 109.051 24.533C109.303 25.3235 110.035 25.9006 110.909 25.9006C111.99 25.9006 112.867 25.023 112.867 23.9406V18.3204C112.867 18.2261 112.853 18.136 112.84 18.046C112.852 17.8645 112.867 17.6845 112.867 17.5009C112.867 12.8687 109.102 9.10107 104.473 9.10107Z",
    fill: "#3C3C3B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_201_22591",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 9,
    width: 18,
    height: 17
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.322 9.1001H131.11V25.9002H114.322V9.1001Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_201_22591)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.689 15.5552C119.415 14.0576 120.945 13.021 122.716 13.021C124.481 13.021 126.007 14.0511 126.735 15.54H118.841C118.789 15.54 118.74 15.5516 118.689 15.5552ZM122.716 9.1001C118.088 9.1001 114.322 12.8684 114.322 17.5006C114.322 22.1321 118.088 25.9004 122.716 25.9004C123.798 25.9004 124.675 25.0227 124.675 23.9404C124.675 22.858 123.798 21.9803 122.716 21.9803C120.945 21.9803 119.415 20.9423 118.689 19.4447C118.74 19.449 118.789 19.4606 118.841 19.4606H129.151C130.233 19.4606 131.11 18.583 131.11 17.5006C131.11 12.8684 127.344 9.1001 122.716 9.1001Z",
    fill: "#3C3C3B"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMirinaeLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-mirinae-logo.7a3aad62f27f8b18da4fc4c1bfff2a50.blank.svg";